import { render, staticRenderFns } from "./Alertmsg.vue?vue&type=template&id=39f357da"
import script from "./Alertmsg.vue?vue&type=script&lang=js"
export * from "./Alertmsg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports